import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Call Handoff v2 Configuration Validator
 * Validates handoff configuration including destination agent and variables
 */
export const Call_Handoff_2_ConfigValidator = z.object({
    destinationAgentId: requiredString('Destination agent is required'),
    destinationLabelId: z.string().nullable().optional(),
    message: z.string().optional(),
    agentVariables: z.record(z.string(), z.any()).optional(),
    includeTranscript: z.boolean().optional()
});
//# sourceMappingURL=call-handoff-2.js.map